import ModalComponent from "@modal/App.vue";
import ModalComponentRouter from "@modal/router";
import storeGlobal from "@/store";

export default {
  component: ModalComponent,
  router: ModalComponentRouter,
  store: storeGlobal,
};
